import PropTypes from 'prop-types';

export const TicketPropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  status: PropTypes.string,
  priority: PropTypes.string,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  assignedTo: PropTypes.string,
  assignmentType: PropTypes.string,
  ecPositionId: PropTypes.string,
  sliceId: PropTypes.number,
  workingCountry: PropTypes.string,
  departmentLabel: PropTypes.string,
  workingLocationLabel: PropTypes.string,
});

export const TicketListPropType = PropTypes.arrayOf(TicketPropType);
